import { render, staticRenderFns } from "./spinnerLoaderComponent.vue?vue&type=template&id=6095f622&scoped=true&"
import script from "./spinnerLoaderComponent.vue?vue&type=script&lang=js&"
export * from "./spinnerLoaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./spinnerLoaderComponent.vue?vue&type=style&index=0&id=6095f622&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6095f622",
  null
  
)

export default component.exports